'use client'
import { createComponents } from '@theme/shared/dark/create-components.jsx';
import { createPalette } from './create-palette';
import { createShadows } from './create-shadows';

export const createOptions = (config) => {
  const { colorPreset, contrast, branding } = config;
  const palette = createPalette({ colorPreset, contrast, branding });
  const components = createComponents({ palette });
  const shadows = createShadows();

  return {
    components,
    palette,
    shadows,
  };
};
